<template>
    <div
        :class="[
            'input-wrap-container',
            {
                error: isError,
            },
        ]"
    >
        <div class="input-wrap">
            <label v-if="label" :for="id" class="label">
                {{ label }}

                <span
                    v-if="validation && validation.required !== undefined"
                    class="is-required"
                >
                    *
                </span>
            </label>

            <textarea
                :id="id"
                :name="id"
                :class="['input', `input-textarea`]"
                :value="value"
                :placeholder="placeholder"
                :rows="rows"
                @input="updateValue"
                @blur="handleBlur"
            />
        </div>

        <ErrorMessages
            v-if="isError"
            :label="label"
            :validation="validation"
            class="error-message-wrap"
        />
    </div>
</template>

<script>
const ErrorMessages = () => import('@/components/form/error-messages');

export default {
    name: 'TextareaWrap',

    components: {
        ErrorMessages,
    },

    props: {
        id: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: false,
            default: '',
        },
        placeholder: {
            type: String,
            required: false,
            default: null,
        },
        validation: {
            type: Object,
            required: false,
            default: undefined,
        },
        value: {
            type: String,
            required: true,
        },
        rows: {
            type: [String, Number],
            required: false,
            default: 2,
        },
    },

    computed: {
        isError() {
            if (this.validation) {
                return this.validation.$error;
            } else {
                return false;
            }
        },
    },

    methods: {
        updateValue($event) {
            this.$emit('input', $event.target.value);
        },

        handleBlur() {
            if (this.validation) {
                this.validation.$touch();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
$label-width: 7rem;
$label-right-margin: 1rem;
$form-padding: 2rem;

.input-wrap-container {
    width: 100%;

    .input-wrap {
        display: flex;
        justify-content: space-between;
        align-items: baseline;

        .label {
            flex-basis: $label-width;
            flex-shrink: 0;
            transition: all 350ms cubic-bezier(0.25, 0.8, 0.25, 1);
            color: $color-medium-gray;
            font-weight: $font-weight-semibold;
            text-align: end;
            margin-right: $label-right-margin;

            .is-required {
                color: $color-error;
            }
        }
        .input {
            flex: auto;
            margin-top: 6px;
            width: calc(
                100% -
                    (
                        #{$label-right-margin} + #{$label-width} + #{$form-padding}
                    )
            );
            padding: 0.5rem 1rem;
            resize: vertical;
            font-size: $font-size-base;
            font-family: $font-family;
            background-color: $color-font-light;
            line-height: 1;
            border: 1px solid $color-light-gray;
            border-radius: $rounded;
            outline: none;
            transition: all 350ms cubic-bezier(0.25, 0.8, 0.25, 1);
            &::placeholder {
                color: $color-medium-gray;
            }
        }
    }

    .error-message-wrap {
        margin-left: calc(#{$label-width} + #{$label-right-margin});
    }
}

.input-wrap-container:focus-within {
    .input {
        border-color: $color-secondary;
    }
}

.input-wrap-container.error {
    .label {
        color: $color-error;
    }
    .input {
        border-bottom-color: $color-error;
        &:focus {
            border-bottom-color: $color-error;
        }
    }
}

.list-enter-active,
.list-leave-active,
.list-move {
    transition: all 350ms cubic-bezier(0.25, 0.8, 0.25, 1);
}
.list-enter,
.list-leave-to {
    opacity: 0;
    height: 0;
}
</style>
